// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Lx-z","tooltipWrapper":"Mx-z","icon":"Nx-z","tooltip":"Ox-z","content":"Px-z"};